import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

// Получить все сигналы
export const apiGetSignalsData = async (nextUrl = null) => {
  const url = nextUrl || `${backendUrl}/api/signals/`;

  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(`Ошибка сети при получении сигналов: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка API получения сигналов:', error);
    throw error;
  }
};